export const MAX_ZOOM = 2;
export const MIN_ZOOM = 0.1;

export const MINIMAP_WIDTH = 78;
export const MINIMAP_HEIGHT = 52;

export const NODE_INTERSECTION_PADDING = 20;
export const FORCE_STRENGTH = 1.2;

export const MAX_RESOLVE_INTERSECTIONS_ITERATIONS = 12;

export const FIXED_NODE_MASS = 4;
export const GENERIC_NODE_MASS = 1;
